(function () {
  'use strict';
  var PX = 'sp';
  function T() { return window.Theme; }
  function words() { var el = document.getElementById(PX + '-ui-strings'); try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } }
  function money(c) { try { return T().money.format(c); } catch (e) { return '$' + (Number(c || 0) / 100).toFixed(2); } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
  function pic(src, w) {
    if (!src) return '<span class="' + PX + '-ui__ph" aria-hidden="true"></span>';
    var u = /^data:/.test(src) ? src : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w * 2);
    return '<img src="' + esc(u) + '" alt="" width="' + w + '" height="' + w + '" loading="lazy">';
  }
  function count(n, W) { return n + ' ' + (n === 1 ? (W.item_one || 'item') : (W.item_other || 'items')); }
  function cartUrl() { return (T() && T().routes && T().routes.cart) || '/cart'; }
  function checkoutUrl() { return (T() && T().routes && T().routes.checkout) || '/checkout'; }
  var lastAdded = null, lastFocus = null;
  function trap(box, e) {
    if (e.key !== 'Tab') return;
    var f = box.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'); if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  }
  function start(fn) { if (window.Theme && window.Theme.events) fn(); else document.addEventListener('DOMContentLoaded', function () { if (window.Theme) fn(); }); }

  var CHECK = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  var CLOSE = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>';

  /* ---- <sp-marquee>: the only JS the hero needs is the pause button ---- */
  if (!customElements.get('sp-marquee')) {
    customElements.define('sp-marquee', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this._btn = this.querySelector('[data-sp-pause]');
        if (!this._btn) return;
        this._click = function () {
          var paused = !self.classList.contains('is-paused');
          self.classList.toggle('is-paused', paused);
          self._btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
          var t = self._btn.querySelector('[data-sp-pause-text]');
          if (t) t.textContent = self.getAttribute(paused ? 'data-play' : 'data-pause') || t.textContent;
        };
        this._btn.addEventListener('click', this._click);
      }
      disconnectedCallback() {
        if (this._btn && this._click) this._btn.removeEventListener('click', this._click);
      }
    });
  }

  /* ---- <sp-toggle>: two radios drive two panels (without JS both panels stay visible) ---- */
  if (!customElements.get('sp-toggle')) {
    customElements.define('sp-toggle', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this._sync = function () {
          var on = self.querySelector('.sp-switch__input:checked');
          var i = on ? Number(on.value) : 0;
          self.setAttribute('data-ready', '');
          self.setAttribute('data-pos', String(i));
          [].forEach.call(self.querySelectorAll('[data-sp-panel]'), function (p) { p.hidden = Number(p.getAttribute('data-sp-panel')) !== i; });
        };
        this.addEventListener('change', this._sync);
        this._sync();
      }
      disconnectedCallback() { this.removeEventListener('change', this._sync); }
    });
  }

  /* ---- "Added to your cart" modal ---- */
  var el = null, body = null;
  function onKey(e) {
    if (!el || !el.classList.contains('is-open')) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    trap(el, e);
  }
  function build() {
    if (el && document.body.contains(el)) return el;
    var W = words();
    el = document.createElement('div');
    el.className = PX + '-ui';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<div class="' + PX + '-ui__scrim" data-ui-close></div>' +
      '<div class="' + PX + '-ui__dialog" role="dialog" aria-modal="true" aria-labelledby="' + PX + '-ui-title" tabindex="-1">' +
      '<button type="button" class="' + PX + '-ui__x" data-ui-close aria-label="' + esc(W.close) + '">' + CLOSE + '</button>' +
      '<div class="' + PX + '-ui__content"></div></div>';
    el.addEventListener('click', function (e) { if (e.target.closest('[data-ui-close]')) close(); });
    document.addEventListener('keydown', onKey);
    document.body.appendChild(el);
    body = el.querySelector('.' + PX + '-ui__content');
    return el;
  }
  function render(it, c) {
    var W = words();
    var unit = it.final_price != null ? it.final_price : (it.final_line_price || 0) / (it.quantity || 1);
    var line = it.final_line_price != null ? it.final_line_price : unit * (it.quantity || 1);
    var img = it.image || (it.featured_image && it.featured_image.url) || '';
    var variant = it.variant_title && !/^default title$/i.test(it.variant_title) ? '<p class="' + PX + '-ui__variant">' + esc(it.variant_title) + '</p>' : '';
    return '<span class="' + PX + '-ui__ok">' + CHECK + '</span>' +
      '<h2 class="' + PX + '-ui__title" id="' + PX + '-ui-title">' + esc(W.added) + '</h2>' +
      '<div class="' + PX + '-ui__item"><div class="' + PX + '-ui__pic">' + pic(img, 88) + '</div>' +
      '<div><a class="' + PX + '-ui__name" href="' + esc(it.url || cartUrl()) + '">' + esc(it.product_title || it.title) + '</a>' + variant +
      '<p class="' + PX + '-ui__qty">' + esc(it.quantity) + ' × ' + money(unit) + '</p></div>' +
      '<span class="' + PX + '-ui__line">' + money(line) + '</span></div>' +
      '<div class="' + PX + '-ui__sum"><span>' + esc(W.subtotal) + ' <span class="' + PX + '-ui__n">(' + count(c.item_count, W) + ')</span></span><strong>' + money(c.total_price) + '</strong></div>' +
      '<p class="' + PX + '-ui__ship">' + esc(W.ship) + '</p>' +
      '<div class="' + PX + '-ui__actions"><a class="' + PX + '-btn ' + PX + '-btn--solid" href="' + esc(checkoutUrl()) + '">' + esc(W.checkout) + '</a>' +
      '<a class="' + PX + '-btn ' + PX + '-btn--ghost" href="' + esc(cartUrl()) + '">' + esc(W.view_cart) + '</a></div>' +
      '<button type="button" class="' + PX + '-ui__keep" data-ui-close>' + esc(W.keep) + '</button>';
  }
  function openUi(it) {
    build();
    lastFocus = document.activeElement;
    T().cart.get().then(function (c) {
      var item = it || (c.items && c.items[0]);
      if (!item) return;
      body.innerHTML = render(item, c);
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      var dlg = el.querySelector('[role="dialog"]');
      if (dlg) dlg.focus();
    }).catch(function () {});
  }
  function close() {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus();
  }
  function afterAdd(after) {
    if (after === 'cart') return false;
    var it = lastAdded && lastAdded.items && lastAdded.items[0];
    openUi(it);
    return true;
  }

  start(function () {
    T().events.on('cart:added', function (e) { lastAdded = e.detail || null; });
    T().afterAddHook = function (after) { return afterAdd(after); };
    if (typeof init === 'function') init();
  });
})();

/* phone buy bar (<PX-mbar>) + cart checkout bar visibility */
(function () {
  'use strict';
  var PX = 'sp';
  function fmt(c) { try { return window.Theme.money.format(c); } catch (e) { return '$' + (Number(c || 0) / 100).toFixed(2); } }
  if (!customElements.get(PX + '-mbar')) customElements.define(PX + '-mbar', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.main = document.querySelector('.' + PX + '-pdp .product-form__submit');
      if (!this.main || !('IntersectionObserver' in window)) return;
      this.io = new IntersectionObserver(function (es) {
        var e = es[0]; self.show(!e.isIntersecting && e.boundingClientRect.top < 0);
      });
      this.io.observe(this.main);
      this.addEventListener('click', function (e) {
        if (!e.target.closest('[data-mbar-add]') || self.main.disabled) return;
        self.main.click();
      });
      this.onVariant = function (e) {
        var v = e.detail && e.detail.variant; if (!v) return;
        var p = self.querySelector('[data-mbar-price]'), b = self.querySelector('[data-mbar-add]');
        if (p) p.textContent = fmt(v.price);
        if (b) { b.disabled = !v.available; b.textContent = v.available ? self.dataset.add : self.dataset.sold; }
      };
      document.addEventListener('variant:change', this.onVariant);
    }
    show(on) { this.classList.toggle('is-in', on); document.documentElement.classList.toggle(PX + '-has-mbar', on); }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.onVariant) document.removeEventListener('variant:change', this.onVariant);
      document.documentElement.classList.remove(PX + '-has-mbar');
    }
  });
})();
